<template>
  <div class="generalPage">
    <div class="isotopeGrid">

      <div class="section1">
        <div class="title_wrapper">
          <p class="title">
            預防一般昆蟲小貼士
          </p>
          <p class="subTitle">
            您的第一道防線
          </p>
        </div>
      </div>

      <div class="section2">
        <div class="generalWrapper">
          <h1>屋內</h1>
          <p>昆蟲需要食物、水、溫暖和黑暗的空間讓它們隱藏，如果不將家居保持乾淨就有機會被昆蟲入侵。請細看以下防止預防蟲入侵的小貼士：</p>

          <h1>廚房</h1>
          <ul>
            <li>請使用有蓋垃圾桶及保持乾淨，並定期清理裡面的垃圾。</li>
            <li>螞蟻和曱甴往往會聚集在櫃和爐子下方，因此請定期清潔該地方，確保沒有水和碎屑。</li>
            <li>雪櫃頂部和底部都很溫暖，會吸引昆蟲。所以，請定期清潔這些地方， 尤其要掃走食物碎屑和抹走污跡。</li>
            <li>因為螞蟻和曱甴會被食物吸引，請將食物存放在玻璃、塑料或充分密封的容器中，以防止昆蟲進入。</li>
            <li>螞蟻和曱甴傾向於有水源的地方附近聚集和隱藏，所以家裡滴漏的水槽會吸引它們。為防止昆蟲進入，請立刻修理和抹乾這些區域。</li>
            <li>所有抽屜，橫架和櫥櫃應排列整齊，如有損壞，請盡快修理，以確保曱甴不會有隱藏的地方。如有使用膠墊或紙墊，請保持平坦，以免昆蟲隱藏在墊下。</li>
          </ul>
          
          <h1>浴室</h1>
          <ul>
            <li>請使用有蓋垃圾桶及保持乾淨，並定期清理裡面的垃圾。</li>
            <li>螞蟻和曱甴喜愛潮濕環境，所以應定期檢查潮濕的地方，如水槽的上方和下方、廁所後面和浴缸附近有否洩漏。 如有裂縫應立刻密封。</li>
            <li>請將濕毛巾和牙刷從抽屜和櫃中取出，以免吸引昆蟲。</li>
          </ul>

          <h1>客廳</h1>
          <ul>
            <li>螞蟻和曱甴喜歡溫暖的地方，可能會聚集在電視機後方或其他電子產品之間。請定期檢查這些地方。</li>
            <li>沙發和椅子附近可能有食物碎屑。請保持這些區域乾淨，檢查是否有昆蟲出沒。</li>
            <li>因為昆蟲經常藏在木材中，所以請檢查所有木材後才帶回家中。</li>
          </ul>

          <h1>其他地方</h1>
          <p>
            您知道幾項簡單的預防措施就可以防止昆蟲的入侵嗎？<br>
            預防勝於治療，防止昆蟲入侵的每一步都很重要。
          </p>
          <ul>
            <li>將所有食物存放在密閉的容器中，避免螞蟻和曱甴進食。</li>
            <li>請洗淨用完的碗碟及杯。</li>
            <li>使用矽膠把所有外部開口和裂縫密封。</li>
            <li>經常清潔枱面及櫃面以除去食物殘渣。</li>
            <li>請盡快洗淨水槽中骯髒的碗碟和器具。</li>
            <li>請避免讓植物接觸房屋/建築物的外部。</li>
            <li>請定期清理廚房以減少隱藏的食物殘渣和肉眼看不見的碎屑。</li>
          </ul>
        </div>
      </div>

      <div class="backbar_wrapper">
        <div class="backbar">
          <router-link :to="'/preventiontips/tips'">
            <img class="icon" src="../assets/icon-chevron.svg">
            <p>返回</p>
          </router-link>
        </div>
      </div>

    </div>
    <contact></contact>
    <henkel-footer></henkel-footer>
  </div>
</template>

<script>
export default {
  created () {
    window.document.title = '威滅Combat 速效藥餌'
    window.scrollTo(0, 0)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import "../styles/_vars.sass"
@import "../styles/_isotopeGrid.sass"

.generalPage
  padding-top: $topMenu-height

</style>



// WEBPACK FOOTER //
// PTipsTipsGeneral.vue?3de01389